export const REQUIRED_FIELD = 'This field is required.';
export const ERROR_OCCURED = 'An error occured, Please try again.';
export const MESSAGES = {
    FunctionNotImplemented: "Function not implemented.",
    MessageDialogDelete:(item:string)=>`Are you sure you want to delete the item titled "${item}"? This action cannot be undone.`,
      MessageDialogCopy:(item:string)=>`Are you sure you want to copy the item titled "${item}"? This action cannot be undone.`,
    MessageMarkScriptHas: "Are you sure you want to mark this script as",
    MessageActionWillUpdateScriptStatus: " This action will update the script's status.",
    MessageUploadScript: "Please upload a script",
    MessageUploadIac: "Please upload an Iac File",
    MessageSucessFully: "Successfully saved",
    MessageUpdateSucessFully: "Successfully Updated",
    MessageSucessFullyConfigFile: "Config File Successfully Added",
    MessageSucessFullyRemoved: "Successfully removed.",
    MessagemDecommission:"The decommissioning process has been initiated.",
    MessageConfirmThis: "Are you sure you want to confirm this?",
    MessageConfirmDelete: "Are you sure you want to delete this?",
    ErrorDelectingScript:"Error deleting script:",
    MessageDecommission:"Decommissioning process is about to begin. Do you wish to proceed?",
    ErrorDecommission:"Error trying to initialize decommission",
    ErrorDecommissionIdMissing:"Item ID is missing. Cannot proceed with decommissioning.",
    CloudInitRequired: "Cloud Init Required",
    CommandsRequired:"Commands is Required",
    MessagesRequired: "Rules is required",
     MessagesDescriptionRequired: "Description is required",
    MessageErrorSavingScriptConfigFile:"Error Adding Config File:",
    /** Required */
    MessageCloudProviderRequired: "Cloud Provider is required",
    MessageCloudEnvironmentRequired: "Cloud Environment is required",
    MessageScriptTypeRequired: "Script Type is required",
    MessageDescriptionRequired: "Description is required",
    MessageTitleRequired:"Title is Required",
    MessageSearchRequired:"Search is Required",
    MessageProvisioningTemplateRequired:"Provisioning Template is required",
    MessageVmConfigurationRequired:"Vm Configuration is Required",
    MessageVmPostProvisioningRequired:"Vm Post Provisioning is required",
    MessageVmPolicyRequired:"Vm Policy is required",
    MessageOsRequired: "Os is Required",
    MessageCpuCoreRequired:"Cpu Cores is Required",
    MessageRamRequired:"Ram is Required",
    MessageStorageRequired:"Storage is Required",
    MessageTemplateRemoved:"Template removed successfully ✅",
    MessageRegexEnvironmentName:"Name must follow the RFC 1123 convention: only lowercase letters, numbers, '-' or '.', and must start and end with a letter or number (e.g., my-env-1, my.env-2, cloud.env1).",
    MessageRegexEnvironmentDescriptions:"This field must be empty or contain at least 3 characters.",
    MessageErrorSaveCloudProvisionerOvh:"Error Saving Cloud Provisioner",
    MessageErrorSaveCloudProvisionerIonos:"Error Saving Cloud Provisioner",
    MessageErrorSavingCloudEnvironment:"Error Saving cloud Environment",
    MessageErrorUpdatingCloudEnvironment:"Error Update cloud Environment",
    MessageErrorSavingScript:"Error saving script"

}
